/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var IOS12 = mp.marketing.trends.widgets.OSAdoption.extend({
    get_previous_version() {
      return mp.marketing.trends.utils.IOS_11;
    },
    get_new_version() {
      return mp.marketing.trends.utils.IOS_12;
    },
    getDownloadName() {
      return ns.IOS12.nice_name;
    },
  });

  Object.assign(IOS12, {
    slug: `ios_12`,
    nice_name: `iOS 12 adoption`,
    description: `How quickly are consumers upgrading to iOS 12?`,
  });
  ns.IOS12 = IOS12;
});

}.call(window));